(ns hai.web-app.viewport
  "Viewport classification (mobile/desktop) derived from `:window/width`, at
   the shared breakpoint ([[hai.ui.viewport]])."
  (:require
   [hai.ui.rf-sugar :refer [defsub]]
   [hai.ui.viewport :as ui-viewport]))

(defsub ::mobile?
  [width :<- [:window/width]]
  ;; `js/window.innerWidth` fallback avoids a one-tick desktop flash before
  ;; `:window/listen-size` writes the initial value to db.
  (let [w (or width (when (exists? js/window) (.-innerWidth js/window)))]
    (ui-viewport/mobile-width? w)))
